var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.4 22.9",
    style: {
      enableBackground: "new 0 0 25.4 22.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,22.9c-0.2,0-0.4,0-0.6-0.1C5.3,22.5,5,22,5,21.5v-4.7H1.5c-0.8,0-1.5-0.7-1.5-1.5V1.5C0,0.7,0.7,0,1.5,0H24 c0.8,0,1.5,0.7,1.5,1.5v13.9c0,0.8-0.7,1.5-1.5,1.5H14l-6.6,5.8C7.2,22.8,6.8,22.9,6.5,22.9z M2.9,13.9h3.6c0.8,0,1.5,0.7,1.5,1.5 v2.9l4.6-4c0.3-0.2,0.6-0.4,1-0.4h9v-11H2.9V13.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,8.5c0,0.9-0.7,1.5-1.5,1.5c-0.9,0-1.5-0.7-1.5-1.5S11.9,7,12.7,7C13.6,7,14.3,7.7,14.3,8.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.5c0,0.9-0.7,1.5-1.5,1.5C5.7,10.1,5,9.4,5,8.5S5.7,7,6.5,7C7.4,7,8.1,7.7,8.1,8.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,8.5c0,0.9-0.7,1.5-1.5,1.5c-0.9,0-1.5-0.7-1.5-1.5S18,7,18.9,7C19.7,7,20.4,7.7,20.4,8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentions);
export default __webpack_public_path__ + "static/media/mentions.8e77734d9b465d6d3ee6a69ac0b9eb25.svg";
export { ForwardRef as ReactComponent };